import React, { createContext, useContext, useState, useEffect } from "react";

const TitleContext = createContext();

export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState("Rubberneck");
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const updatePageTitle = (newTitle, suffix = null) => {
    const fullTitle = suffix ? `${newTitle} - ${suffix}` : newTitle;
    setPageTitle(fullTitle);
  };

  return (
    <TitleContext.Provider
      value={{
        pageTitle,
        updatePageTitle,
        breadcrumbs,
        setBreadcrumbs,
      }}
    >
      {children}
    </TitleContext.Provider>
  );
};

export const usePageTitle = () => {
  const context = useContext(TitleContext);
  if (!context) {
    throw new Error("usePageTitle must be used within a TitleProvider");
  }
  return context;
};
